import { type BuildDetailsFieldsParams, field, typedField, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildPartnershipGoalsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const salesAndForecast = opportunity?.sales_and_forecast;
  const productAndSoloTraveller = opportunity?.product_and_solo_traveller;

  return [
    typedField(
      'Room Night Target',
      salesAndForecast?.room_night_target__c,
      'number',
      'Room night target communicated to the hotel as a minimum production.',
      { columns: 2 },
    ),
    withLayout(field('Primary Market', salesAndForecast?.primary_market__c), { columns: 2 }),
    withLayout(
      field('Hotel Goals', productAndSoloTraveller?.hotel_goals__c, 'What problem are we solving for the hotel.', true),
      {
        columns: 2,
        span: 'full',
      },
    ),
  ];
}
